import { Injectable } from '@angular/core';
import { ApiService } from './api/api.service';

@Injectable({
    providedIn: 'root',
})
export class QuestionsService {
    constructor(private apiService: ApiService) {}

    public getQuestions(toolboxId) {
        return this.apiService.getCallData$<Question[]>(`toolbox/questions/${toolboxId}`);
    }

    public saveQuestion(toolboxId, question: QuestionResponse) {
        return this.apiService.postCall$<Question>(`toolbox/questions/save/${toolboxId}`, question);
    }

    public deleteQuestion(questionId) {
        return this.apiService.deleteCall$<Question>(`toolbox/questions/${questionId}`);
    }

    public deleteChoice(choiceId) {
        return this.apiService.deleteCall$<Choice>(`toolbox/questions/choice/${choiceId}`);
    }

    public registerAnswer(answer) {
        return this.apiService.postCall$<Answer>(`toolbox/question/answer`, answer);
    }

    public getToolboxQuizAnswers(toolboxId) {
        return this.apiService.getCallData$<Answer[]>(`toolbox/question/answer/${toolboxId}/all`);
    }

    public getToolboxQuizAnswersByUser(toolboxId) {
        return this.apiService.getCallData$<Answer[]>(`toolbox/questions/answers/${toolboxId}`);
    }

    public getToolboxQuizStats(toolboxId) {
        return this.apiService.getCallData$(`toolbox/question/answer/${toolboxId}`);
    }
}

export interface Choice {
    id?: number;
    text: string;
    is_correct: boolean;
}

export interface Question {
    id?: number;
    text?: string;
    question: string;
    toolbox_id: number;
    choices: Choice[];
}

export interface QuestionResponse {
    questions: Question[];
}

export interface Answer {
    question_id: number;
    user_id: number;
    choice_id: number;
    is_correct: boolean;
    toolbox_id: number;
}
